import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './register.css'
import { BounceLoader } from 'react-spinners';
import ReCAPTCHA from "react-google-recaptcha";
import { EnterOtp, RegisterData, GetCadre } from '../../information/actions';
import swal from 'sweetalert';
import { loaderEnd, loaderStart } from '../../components/loader';


const Register = () => {
    const navigate = useNavigate()
    const [mobile, setMobile] = useState();
    const [reCaptcha, setReCaptcha] = useState(false)
    const [val, setVal] = useState({
        name: "",
        aadhar: "",
        service: "",
        service_cadre: "",
        mobile: "",
        email: "",
        dob: "",
        otp: "",
    })
    const [allCadre, setAllCadre] = useState([])

    const getData = async () => {
        let data = await GetCadre()
        setAllCadre(data.data)
    }
    useEffect(() =>{
        getData()
    }, [])


    // const onRegister = () => {
    //   loaderStart()
    //   // setTimeout(() => {
    //   navigate('/login')
    //   // }, 2000);
    //   loaderEnd()
    // }
    const captchaClick = (e) => {
        setReCaptcha(e);
    }
    const handleChange = (e) => {
        setVal({ ...val, [e.target.name]: e.target.value })
    }

    const onRegister = async (e) => {
        e.preventDefault()
        loaderStart()
        if (reCaptcha) {
            console.log(val, val.aadhar.length);
            if (val.name === '') {
                swal("Please Enter Your Name", "", "error")
            }
            else if (val.aadhar === '' || (val.aadhar.length != 12 && val.aadhar)) {
                swal("Please Enter correct aadhar number", "", "error")
            } else if (val.service === '') {
                swal("Please Select Service", "", "error")
            } else if (val.service_cadre === '') {
                swal("Please Select Service Cadre", "", "error")
            } else if (val.email === '') {
                swal("Please Enter Email Id", "", "error")
            } else if (val.dob === '') {
                swal("Please Enter Date of Birth", "", "error")
            }
            else {
                let sendval = {
                    name: val.name,
                    aadhar: val.aadhar,
                    service: val.service,
                    service_cadre_code: val.service_cadre,
                    service_cadre:"",
                    mobile: mobile,
                    email: val.email,
                    dob: val.dob,
                    capcha: "asdas",
                    otp: val.otp
                }
                let res = await RegisterData(sendval)
                console.log(res);
                if (res.code === 1) {
                    swal("Your registration is successful. Please login to register for exam.", "", "success")
                    navigate('/login')
                } else {
                    swal(res.message, "", "error")
                }
            }
        }
        else {
            swal("Please Verify captcha to Continue", "", "error")
        }
        loaderEnd()
    }

    const handleOtp = async () => {
        if (mobile) {
            let val = {
                phone: mobile,
            }
            let res = await EnterOtp(val)
            if (res.code === 1) {
                swal(res.message, "Please check Your Mobile Or Email for Otp", "success")
                    .then((value) => {
                        return
                    });
            }
        }
        else {
            swal("Please Enter Mobile Number Continue", "", "error")
        }
    }

    return (
        <>
            <section className='login'>
                <div className='register-container'>
                    <div className='instruction ui_auth_aside'>
                        <h3>GENERAL INSTRUCTIONS / सामान्य निर्देश</h3>
                        <hr />
                        <ul className='ui_auth_list'>
                            <li>Incomplete application form shall be rejected.</li>
                            <li>अपूर्ण आवेदन पत्र स्वीकार्य नहीं होंगे।</li>
                            <li>Please read all the instructions carefully before filling up the form.</li>
                            <li>कृप्या प्रपत्र भरने से पहले सभी निर्देशों को ध्यानपूर्वक पढ़ें।</li>
                            <li>Applicant’s signature is mandatory on the application form.</li>
                            <li>आवेदन पत्र पर प्रार्थी का हस्ताक्षर अनिवार्य है।</li>
                            <li>Please make sure the details mentioned in the application form are the same as the details filled in the examination hall.</li>
                            <li>कृपया सुनिश्चित करें कि आवेदन पत्र में उल्लिखित विवरण परीक्षा हॉल में भरे जाने वाले विवरण के समान होना चाहिए।</li>
                            <li>Select your date of birth carefully — it will be your password.</li>
                            <li>कृप्या तिथि, महीना और वर्ष सही तरीके से चुनें। आपकी जन्मतिथि आपका पासवर्ड होगा।</li>
                            <li>A valid mobile number is required to receive the OTP.</li>
                            <li>वन टाइम पासवर्ड (OTP) प्राप्त करने के लिए मोबाइल नंबर महत्वपूर्ण है।</li>
                        </ul>
                    </div>

                    <div className='form'>
                        <div className='ui_panel'>
                            <div className='ui_panel_head'>
                                <h2 className='ui_panel_title'>Candidate Registration</h2>
                            </div>

                            <form onSubmit={onRegister} className='ui_panel_body'>
                                <p className='ui_note_required'>Fields marked with * are mandatory</p>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_name'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-user' aria-hidden='true'></i>
                                        Full Name / पूरा नाम
                                    </label>
                                    <input
                                        id='reg_name'
                                        type='text'
                                        placeholder='First Middle Last'
                                        className='ui_input'
                                        name='name'
                                        value={val.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_aadhar'>
                                        <span className='ui_required'>*</span>
                                        <i className='fas fa-id-card' aria-hidden='true'></i>
                                        Aadhaar Number / आधार संख्या
                                    </label>
                                    <input
                                        id='reg_aadhar'
                                        type='text'
                                        maxLength={12}
                                        title='Please enter exactly 12 digits'
                                        className='ui_input'
                                        placeholder='12-digit Aadhaar number'
                                        required
                                        name='aadhar'
                                        value={val.aadhar}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_service'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-briefcase' aria-hidden='true'></i>
                                        Service / सेवा
                                    </label>
                                    <select
                                        id='reg_service'
                                        name='service'
                                        required
                                        onChange={handleChange}
                                        value={val.service}
                                        className='ui_select'
                                    >
                                        <option value=''>Select Service</option>
                                        <option value='Gazetted'>Gazetted</option>
                                        <option value='Non-Gazetted'>Non-Gazetted</option>
                                    </select>
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_cadre'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-address-book' aria-hidden='true'></i>
                                        Service Cadre / सेवा संवर्ग
                                    </label>
                                    <select
                                        id='reg_cadre'
                                        required
                                        name='service_cadre'
                                        className='ui_select'
                                        onChange={handleChange}
                                        value={val.service_cadre}
                                    >
                                        <option value=''>Select Service Cadre</option>
                                        {/* Every <option> previously carried `selected`,
                                            which React warns about and which fights the
                                            controlled `value` on the <select>. */}
                                        {allCadre.map((s) => (
                                            <option key={s.service_cader_code} value={s.service_cader_code}>
                                                {s.description}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_email'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-envelope' aria-hidden='true'></i>
                                        Email / ईमेल
                                    </label>
                                    <input
                                        id='reg_email'
                                        type='email'
                                        placeholder='name@example.com'
                                        className='ui_input'
                                        required
                                        name='email'
                                        value={val.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_dob'>
                                        <span className='ui_required'>*</span>
                                        <i className='fas fa-calendar' aria-hidden='true'></i>
                                        Date of Birth / जन्म तिथि
                                    </label>
                                    <input
                                        id='reg_dob'
                                        type='date'
                                        className='ui_input'
                                        required
                                        name='dob'
                                        value={val.dob}
                                        onChange={handleChange}
                                    />
                                    <span className='ui_hint'>
                                        Select the day, month and year carefully — your date of
                                        birth becomes your password.
                                    </span>
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_mobile'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-mobile' aria-hidden='true'></i>
                                        Mobile Number / मोबाइल नं
                                    </label>
                                    {/* The Send OTP button was a Bootstrap grid column
                                        next to the input, so it wrapped underneath at
                                        narrow widths and lost its alignment. */}
                                    <div className='ui_otp_row'>
                                        <input
                                            id='reg_mobile'
                                            type='number'
                                            name='mobile'
                                            placeholder='10-digit mobile number'
                                            value={mobile}
                                            onChange={e => setMobile(e.target.value)}
                                            className='ui_input'
                                            required
                                        />
                                        <button
                                            type='button'
                                            onClick={handleOtp}
                                            className='ui_btn ui_btn_secondary'
                                        >
                                            Send OTP
                                        </button>
                                    </div>
                                    <span className='ui_hint'>
                                        The one-time password is sent to this number.
                                    </span>
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='reg_otp'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-shield' aria-hidden='true'></i>
                                        Enter OTP
                                    </label>
                                    <input
                                        id='reg_otp'
                                        type='text'
                                        placeholder='One-time password'
                                        required
                                        className='ui_input'
                                        name='otp'
                                        value={val.otp}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label'>
                                        <span className='ui_required'>*</span>
                                        <i className='fa fa-shield' aria-hidden='true'></i>
                                        Verification
                                    </label>
                                    <div className='ui_captcha'>
                                        <ReCAPTCHA
                                            sitekey={"6LdDLf4kAAAAANwu1tRJPKKElBept4LY9R-tVyrs"}
                                            onChange={captchaClick}
                                        />
                                    </div>
                                </div>

                                <button type='submit' className='ui_btn ui_btn_primary ui_btn_block'>
                                    Register
                                </button>

                                <p className='ui_auth_foot'>
                                    Already registered? <a href='/login'>Sign in</a>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Register